import PropTypes from 'prop-types'
import FullPageModal from 'components/FullPageModal'
import Text from 'components/Text'
import Picture from 'components/Picture'
import Title from 'components/Title'
import Button from 'components/Button'
import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

import Input from './Input'

const StyledInput = styled.div`
  input {
    width: ${pxToRem(120)};
    color: black;
  }

  label {
    color: #bba98c;
    margin-bottom: ${pxToRem(10)};
  }

  span {
    color: ${({ theme }) => theme.input_error_color || '#f00000'};
    font-size: ${({ theme }) => pxToRem(theme.input_error_size || 14)};
    padding-top: ${pxToRem(10)};
  }
`

/*
  validation page on trigger inputs has been created for alatable
*/
const AcModal = ({ dataGa, error, input, inputLabel, label, open, register, userInputs, validation }) => (
  <FullPageModal
    isVisible={open}
    content={
      <>
        {validation.title && <Title text={validation.title} />}

        {validation.imageUrl && <Picture inModal url={validation.imageUrl} newTab={false} />}

        {validation.text && <Text text={validation.text} />}

        <StyledInput>
          <Input
            error={error}
            label={inputLabel}
            input={input}
            register={register}
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
            userInputs={userInputs}
          />
        </StyledInput>

        <Button children={label} type="submit" id={`${input.name} button`} />

        {validation.text2 && <Text text={validation.text2} />}

        {validation.imageUrl2 && <Picture inModal url={validation.imageUrl2} newTab={false} />}
      </>
    }
  />
)

AcModal.propTypes = {
  dataGa: PropTypes.string,
  error: PropTypes.string,
  input: PropTypes.object,
  inputLabel: PropTypes.string,
  label: PropTypes.string,
  open: PropTypes.bool,
  register: PropTypes.func,
  userInputs: PropTypes.object,
  validation: PropTypes.object,
}

export default AcModal
